export default "__VITE_ASSET__CZCauwd9__"